import { Component, OnInit } from '@angular/core';
import { Country } from '../country';
import { HttpService } from '../service/http.service';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-lvms-booking-create',
  templateUrl: './lvms-booking-create.component.html',
  styleUrls: ['./lvms-booking-create.component.css']
})
export class LvmsBookingCreateComponent implements OnInit {

  countries: Country[] = [];
  bookingForm!: FormGroup;

  searchTerm!: string;
  searchOption = "name";

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.httpService.getAllCountries().subscribe(countries => {
      this.countries = countries;
      this.bookingForm = this.builder.group({
        searchTerm: "",
        country: null
      });
    });
  }

}
